import * as React from 'react';
import { withRouter } from 'react-router';
import injectSheet from 'react-jss';
import Dropdown from 'antd/lib/dropdown';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Icon from 'antd/lib/icon';
import Tooltip from 'antd/lib/tooltip';
import Modal from 'antd/lib/modal';
import Button from 'antd/lib/button';
import message from 'antd/lib/message';
import Menu from 'antd/lib/menu';
import Spin from 'antd/lib/spin';
import ViewBreakdown from '../Modals/ViewBreakdown';
import { getCreateInvoiceRoute, getInquiryDetailRoute } from 'src/routing/utils';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getAllInquiriesResetFilter,
  getAllInquiriesApplyFilter,
} from 'src/actions/inquiryShipperActions';
import {
  declineBooking,
  fetchBookingDetail,
  cancelInttraBookingRequest,
  createSplitBookings,
  convertBookingNotesToZip,
} from '../../../../../src/api/booking';
import { fetchAllBookings } from 'src/actions/bookingInquiryActions';
import BookingDetail from '../Modals/BookingDetailModal';
import { INQUIRY_FF } from 'src/utils/partsToShow/partsConstants';
import withAuthAccessExim from 'src/components/hoc/withAuthAccessExim';
import { getBidTotal, BookingSource } from '../InquiryUtils';
import CommentCount from '../../../common/comments/CommentCount';
import PricePerContainer from '../../../common/PricePerContainer';
import PriceTotal from '../../../common/PriceTotal';
import ContainerDetails from './ContainerDetails/ContainerDetails';
import ConnectionStatusInquiry from '../ConnectionStatusInquiry';
import { OrganisationOnboardingStatus } from '../../masters/Masters.Helper';
import { EventCategories, sendEvent } from 'src/utils/gaService';
import EllipsisIcon from 'src/components/common/icons/EllipsisIcon';
import { getDateValue, isValidString, isValidArray } from 'src/Library/Helper';
import { commonStyles, buttonStyle } from 'src/Library/CommonStyles';
import { SL_RESPONDED_INTTRA_STATUS, BOOKING_STATUS, bookingSecondaryActions,
  renderBookingOriginDetails, renderBookingDestinationDetails, commentsLocationDetails } from '../Booking/BookingUtils';
import BookingFFModal from '../Booking/BookingFFModal';
import TextArea from 'antd/lib/input/TextArea';
import SplitBookingDetailsModal from './SplitBookingDetailsModal';
import classNames from 'classnames';
import { getConditionalBullets } from 'src/Library/Common';
import { InquiryModes, InquiryType } from 'src/Library/Constants';
import { getEmptyContainerLocation } from './InquiryCommon';
import { tokens } from 'src/design-system';

const styles = (theme: any) => ({
  iconsTheme: {
    '&:hover': {
      color: COLORS.GREEN,
    },
  },
  cardContainer: {
    height: '140px',
    marginTop: '8px',
    padding: '16px 16px 13px 16px',
    backgroundColor: tokens.colors.bgWhite,
    border: '1px solid #D9D9D9',
    borderRadius: `${tokens.radius.md}px`,
  },
  colParent: {
    borderLeft: '1px solid #E8E8E8',
    paddingLeft: '32px',
    height: '95px',
  },
  flex: {
    display: 'flex',
    flex: 1,
  },
  flexRow: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  flexCol: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    height: '105px',
  },
  internalRefNumber: {
    fontSize: `${tokens.fontSize.small}px`,
    margin: '-5px 0px 15px',
    fontWeight: tokens.fontWeight.semibold,
    width: '165px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  confirmedDiv: {
    borderRadius: `${tokens.radius.md}px`,
    color: tokens.colors.bgWhite,
    fontSize: `${tokens.fontSize.small}px`,
    textAlign: 'center',
    width: '100px',
    backgroundColor: '#52C41A',
    border: '1px solid #389E0D',
  },
  bookingNum: {
    color: '#1875F0',
    fontSize: `${tokens.fontSize.h3}px`,
    fontWeight: tokens.fontWeight.semibold,
    lineHeight: '21px',
  },
  inquiryNum: {
    color: '#1875F0',
    fontSize: `${tokens.fontSize.small}px`,
    fontWeight: tokens.fontWeight.semibold,
    lineHeight: '21px',
  },
  absoluteData: {
    position: 'absolute',
    top: '24px',
  },
  noActionsMenu: {
    color: '#999999',
    fontSize: `${tokens.fontSize.small}px`,
    cursor: 'default',
  },
  dataString: {
    fontSize: `${tokens.fontSize.caption}px`,
    color: '#666666',
    paddingLeft: '26px',
    fontStyle: 'italic',
  },
  inttraRefNo: {
    color: '#595959',
    paddingLeft: '26px',
    fontSize: `${tokens.fontSize.small}px`,
    marginTop: '5px',
  },
  slResponded: {
    ...commonStyles(theme).justifySpaceBetween,
    alignItems: 'center',
  },
  slRespondedStatus: {
    color: tokens.colors.textSecondary,
    borderRadius: '15px',
    fontSize: `${tokens.fontSize.small}px`,
    padding: '3px 8px',
    marginRight: '8px',
  },
  slRejected: {
    color: '#F5222D',
    fontSize: `${tokens.fontSize.small}px`,
    fontWeight: tokens.fontWeight.semibold,
    textAlign: 'right',
    cursor: 'pointer',
    paddingRight: '6px',
  },
  actionsMenu: {
    '& .ant-dropdown-menu-item, .ant-dropdown-menu-submenu-title': {
      fontSize: `${tokens.fontSize.small}px`,
    },
  },
  cancelSubmit: {
    ...buttonStyle(tokens.colors.bgWhite, tokens.colors.primary, '1px solid #1890FF'),
    padding: '0 10px',
  },
  cancelButton: {
    cursor: 'pointer',
    color: tokens.colors.textSecondary,
    marginRight: '24px',
  },
  skipNowButton: {
    ...buttonStyle('#424242', '#F2F4F6', '1px solid #DDE0E5'),
    padding: '0 12px',
  },
  cancelInttraSuccessHeader: {
    padding: '24px 0 24px 16px',
    display: 'flex',
    color: '#424242',
    backgroundColor: '#F9F9F9',
    borderBottom: '1px solid rgba(0,0,0,0.09)',
  },
  successIcon: {
    color: '#52C41A',
    margin: '2px 8px 0 0',
  },
  suggestedActions: {
    border: '1px solid #D9D9D9',
    borderRadius: `${tokens.radius.md}px`,
    padding: '8px',
    color: '#262626',
    fontWeight: tokens.fontWeight.semibold,
    width: '48%',
    cursor: 'pointer',
  },
  suggestedActionsDiv: {
    ...commonStyles(theme).justifySpaceBetween,
    marginTop: '12px',
  },
  actionsDiv: {
    position: 'absolute',
    bottom: '-8px',
    right: 0,
    width: '100%',
  },
  tooltipStyle: {
    '& .ant-tooltip-inner': {
      backgroundColor: tokens.colors.textSecondary,
      color: tokens.colors.bgWhite,
    },
  },
  tooltipRightArrow: {
    '& .ant-tooltip-arrow': {
      right: 0,
    },
  },
  emptyContainerLocation: {
    color: '#666666',
    fontSize: `${tokens.fontSize.caption}px`,
    fontStyle: 'italic',
    paddingTop: '4px',
    position: 'absolute',
    left: '24px',
    bottom: '-20px',
  },
  hiddenEllipsis: {
    width: '20%',
    minHeight: '50%',
    ...commonStyles(theme).ellipses,
  }
});

const COLORS = {
  GREEN: '#52C41A',
  RED: '#F5222D',
  BLUE: tokens.colors.primary,
  GREY: '#D9D9D9',
};

class InquiryFFCardStyled extends React.PureComponent<any, any> {
  constructor(props) {
    super(props);

    this.state = {
      loadingBookingData: false,
      newDeadline: null,
      heading: '',
      declining: false,
      loading: false,
      bookingDetailModalVisible: false,
      extendDeadlineModalVisible: false,
      editInquiryModalVisible: false,
      viewBreakdownVisible: false,
      sendRFQVisible: false,
      bidRankData: null,
      isRankDataLoaded: false,
      isDeclineModalVisible: false,
      isUploadDOModalVisible: false,
      isDropdownVisible: false,
      isCancelInttraRequestModalVisible: false,
      cancelRemark: undefined,
      isCancellingInttraRequest: false,
      isCancelInttraRequestSuccessVisible: false,
      isAmend: false,
      loadingAmendBookingData: false,
      isCreateNew: false,
      cancellationRemarksWithCarrier: undefined,
      isRetryInttraRequest: false,
      isSplitBookingDetailsModalVisible: false,
    };
  }

  async componentDidMount() {
    this.setState({
      isRankDataLoaded: true,
      newDeadline: this.props.cardData.deadline,
    });
  }

  handleClickInquiryNumber = () => {
    const { inquiryId } = this.props.cardData;
    this.props.history.push(getInquiryDetailRoute('ff', inquiryId));
  }

  handleClickBookingNumber = () => {
    const { drawerData } = this.props;
    drawerData(this.props.cardData);
  }

  handleClickViewBreakdown = () => {
    this.setState({
      viewBreakdownVisible: true,
    });
  }

  closeViewBreakdown = () => {
    this.setState({
      viewBreakdownVisible: false,
    });
  }

  handleAddNewInvoice = (cardData) => {
    const { history } = this.props;
    history.push(getCreateInvoiceRoute({
      sourceType: 'booking',
      sourceId: cardData.id,
    }));
  }

  renderDot = (style, char) => {
    return <div style={{
      marginBottom: '3px', height: '13px', width: '13px',
      borderRadius: `${tokens.radius.lg}px`, display: 'inline-block',
      verticalAlign: 'middle',
      ...style,
    }}><span style={{ paddingLeft: '2px' }}>{char}</span></div>;
  }

  renderLine = (color) => {
    return <div style={{ display: 'flex', flex: 1, height: '1px', backgroundColor: color }}>
    </div>;
  }

  col4Status = () => {
    const { cardData : { ffStatus, inttraRequestIds }, appliedFilters } = this.props;
    const iconStyle = {
      color: '#fff',
      fontSize: '9px',
      top: '6px',
      position: 'absolute',
    } as React.CSSProperties;
    let backgroundColor;
    let statusValue;
    let char;
    const activeTab = appliedFilters?.statusList;

    switch (ffStatus) {
      case BOOKING_STATUS.OPEN: {
        backgroundColor = '#EABD52';
        statusValue = 'Booking Received';
        break;
      }
      case BOOKING_STATUS.CONFIRMED: {
        backgroundColor = '#6BBA89';
        statusValue = 'Booked';
        break;
      }
      case BOOKING_STATUS.CANCELLED: {
        backgroundColor = '#999999';
        statusValue = 'Cancelled';
        break;
      }
      case BOOKING_STATUS.DECLINED: {
        backgroundColor = '#E35959';
        statusValue = 'Declined';
        break;
      }
      case BOOKING_STATUS.SL_RESPONSE_AWAITED: {
        backgroundColor = '#ED8732';
        statusValue = `SL Response Awaited ${inttraRequestIds?.length > 1 ? ' | Amended' : ''}`;
        break;
      }
      case BOOKING_STATUS.SL_RESPONDED: {
        backgroundColor = '#4785C8';
        statusValue = 'SL Responded';
        break;
      }
      case BOOKING_STATUS.SL_ERRORED: {
        backgroundColor = '#E35959';
        statusValue = 'Errors Received';
        break;
      }
      default: {
        backgroundColor = COLORS.BLUE;
        statusValue = 'Booking Requested';
        break;
      }
    }
    return (
      <div style={{
        fontWeight: tokens.fontWeight.semibold, fontSize: `${tokens.fontSize.body}px`, color: '#252323d9', display: 'inline-block',
      }}>
        {this.renderDot({
          backgroundColor,
          marginRight: '11px',
          marginLeft: '3px',
          verticalAlign: 'middle',
        }, char ? char : '')}
        <span>{statusValue}</span>
      </div>)
      ;
  }

  getStatusDate = () => {
    const { cardData: data, classes } = this.props;
    let date = data.statusDate;
    if (data.ffStatus === BOOKING_STATUS.SL_RESPONSE_AWAITED || data.ffStatus === BOOKING_STATUS.SL_ERRORED) {
      date = data.ffStatusUpdatedAt;
    }
    if (data.ffStatus === BOOKING_STATUS.SL_RESPONDED) {
      date = data.inttraStatusUpdatedAt;
    }

    const statusDate = getDateValue(date)?.format('DD MMM YYYY');
    const statustime = `${getDateValue(date)?.format('HH:mm')} Hrs`;

    if (!statusDate) return;

    return (
      <div className={classes.dataString}>
        <span>{statusDate}</span>
        <span style={{ fontStyle: 'normal' }}> | </span>
        <span>{statustime}</span>
      </div>
    );
  }

  renderDataCol1 = () => {
    const { classes, cardData: data } = this.props;
    return <div className={classes.flexCol}>
      <div style={{ marginBottom: '8px' }}>
        <a className={classes.bookingNum}
          onClick={this.handleClickBookingNumber}>{data.bookingNumber}</a>
        {data.internalReferenceNumber ?
          <Tooltip title={data.internalReferenceNumber}>
            <div className={classes.internalRefNumber}>
              <span style={{ fontWeight: 500, color: '#A7A7A7' }}>Internal # </span>
              {data.internalReferenceNumber}
            </div>
          </Tooltip> : null}
        <Row><strong><Icon type="user" style={{ paddingRight: '6px' }} />
          <span >{data.shipperName}</span></strong></Row>
      </div>
      {data.source !== BookingSource.DIRECT_BOOKING &&
        <div>
        <Row>
          <div style={{ fontSize: `${tokens.fontSize.small}px` }}>Inquiry</div>
        </Row>
        <Row>
          <a className={classes.inquiryNum}
            onClick={this.handleClickInquiryNumber}>{data.inquiryReferenceNumber}</a>
        </Row>
      </div>}
    </div>;
  }

  getContainerType(key) {
    const { containerTypes } = this.props;
    if (!key || !containerTypes) return;
    const type = containerTypes.filter(item => item.key === key);
    if (type.length > 0) return type[0].label;
  }

  renderDataCol2 = () => {
    const { classes, cardData: data } = this.props;
    return (
      <div style={{ width: '100%' }}>
        <div className={classes.flexRow} style={{
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '25px', marginTop: '4px',
          marginRight: '110px',
        }}>
          <div>
            {this.renderDot({ backgroundColor: COLORS.GREY }, '')}
            <div className={classNames(classes.absoluteData, classes.hiddenEllipsis)} style={{
              left: '22px',
            }}>
              {renderBookingOriginDetails(data, classes)}
            </div>
          </div>
          {this.renderLine(COLORS.GREY)}
          <ContainerDetails data={data} />
          {this.renderLine(COLORS.GREY)}
          <div>
            {this.renderDot({ border: `1px solid ${COLORS.GREY}` }, '')}
            <br />
            <div className={classNames(classes.absoluteData, classes.hiddenEllipsis)}
            >
              {renderBookingDestinationDetails(data, classes)}
            </div>
          </div>
        </div>
        <div className={classes.emptyContainerLocation}>
          {data.inquiryMode === InquiryModes.TRAILER &&
          data.emptyContainerLocationPortDetails?.code !== data.destinationPortDetails?.code &&
            getEmptyContainerLocation(data.inquiryType, data.emptyContainerLocationPortDetails?.name)}
        </div>
      </div>
    );
  }

  renderDataCol3 = () => {
    const { classes, cardData } = this.props;
    const bidRankData = cardData.bidDetails;
    return (
      <>
        <Col span={24}>
          <Row>
            <div style={{ fontSize: `${tokens.fontSize.small}px` }}>
              Final Cost
            </div>
          </Row>
          <Row>
            <Col span={24} >
              <div style={{ fontSize: `${tokens.fontSize.h2}px`, color: 'black' }}>
                {this.props.currencySymbols[`${bidRankData.finalPrice.currency}`]}
                {`${getBidTotal(bidRankData.finalPrice.amount)}`}
                { (cardData.status === 'CONFIRMED' || cardData.status === 'OPEN') && cardData.source !== BookingSource.DIRECT_BOOKING ?
                  <span style={{ fontSize: `${tokens.fontSize.small}px`, color: '#242222' }}>
                    | Rank {bidRankData.rank}</span> : null
                }
              </div>
            </Col>
          </Row>
          <Row>
            <div style={{ padding: '0px 0px' }}>
              <Col style={{ margin: '11px 0px 18px' }} span={20}>
                <>
                  <a style={{ fontSize: `${tokens.fontSize.small}px`, color: tokens.colors.primary, margin: '15px 0px 0px 0px' }}
                    onClick={this.handleClickViewBreakdown}>
                    View Breakdown</a>
                  {this.state.viewBreakdownVisible && <ViewBreakdown
                    mode={cardData?.mode}
                    type={'FF'}
                    bookingIdCard={cardData.id}
                    bidId={cardData.bidDetails.id}
                    inquiryId={cardData.inquiryId}
                    visible={this.state.viewBreakdownVisible}
                    handleCancel={this.closeViewBreakdown}
                    handleOk={this.closeViewBreakdown} 
                    source={'BOOKING'}/>}
                </>
              </Col>
            </div>
          </Row>
        </Col>
      </>
    );
  }

  showDeclineConfirmationModal = (isTrue) => {
    this.setState({
      isDeclineModalVisible: isTrue,
    });
  }

  handleBookingDecline = async () => {
    const { cardData } = this.props;
    const { cancellationRemarksWithCarrier } = this.state;
    this.setState({ declining: true });
    const response = await declineBooking({
      cancellationRemarksWithCarrier,
      bookingId: cardData.id,
    });
    if (response.isSuccess) {
      sendEvent(
        EventCategories.INQUIRY_BOOKING_FF,
        'Booking Declined',
      );
      this.props.fetchAllBookings('FF');
    }
    this.setState({ declining: false, isDeclineModalVisible: false });
  }

  handleBook = async (isUploadDO = false) => {
    if (!isUploadDO) {
      sendEvent(
        EventCategories.INQUIRY_BOOKING_FF,
        'Process Booking',
      );
    }
    this.setState({
      loadingBookingData: true,
    });
    const { cardData } = this.props;
    const response = await fetchBookingDetail({
      bookingId: cardData.id,
    });
    if (response.isSuccess) {
      if (isUploadDO) {
        this.setState({
          bookingDetail: response.data,
          loadingBookingData: false,
          isUploadDOModalVisible: true,
          isDropdownVisible: false,
        });
      } else {
        this.setState({
          bookingDetail: response.data,
          loadingBookingData: false,
          bookingDetailModalVisible: true,
        });
      }
    } else {
      message.error(response.errorMessage);
      this.setState({
        loadingBookingData: false,
      });
    }
  }

  renderBookingFFModal = () => {
    const { isUploadDOModalVisible, bookingDetail } = this.state;
    const { cardData : { id, bookingNumber } } = this.props;
    return (
      <BookingFFModal
        isVisible={isUploadDOModalVisible}
        bookingId={id}
        bookingNumber={bookingNumber}
        sailingDate={bookingDetail.bookingDetails.preferredSailingDate}
        handleClose={() => {
          this.setState({
            isUploadDOModalVisible: false,
          });
        }}
        type={'FF'}
        inquiryMode={bookingDetail.bookingDetails.mode}
        bookingData={bookingDetail}
      />
    );
  };

  getMenuItemsToShow = () => {
    const { cardData: { ffStatus, inttraStatus, status } } = this.props;
    if (ffStatus === BOOKING_STATUS.SL_RESPONSE_AWAITED || ffStatus === BOOKING_STATUS.SL_ERRORED) {
      return this.renderSLActions(bookingSecondaryActions[ffStatus]);
    }
    if (ffStatus === BOOKING_STATUS.SL_RESPONDED) {
      return bookingSecondaryActions[ffStatus] &&
        this.renderSLActions(bookingSecondaryActions[ffStatus][inttraStatus]);
    }
    return;
  }

  getActionsDropdown = () => {
    const { classes } = this.props;
    return (
      <Menu className={classes.actionsMenu}>
        {this.getMenuItemsToShow()}
      </Menu>
    );
  };

  handleCancelInttraRequest = async () => {
    const { cancelRemark } = this.state;
    const { cardData : { id } } = this.props;
    this.setState({
      isCancellingInttraRequest: true,
    });
    const body = {
      bookingId: id,
      remarks: cancelRemark,
    }
    const response = await cancelInttraBookingRequest(body);
    if (response.isSuccess) {
      this.setState({
        isCancellingInttraRequest: false,
        isCancelInttraRequestModalVisible: false,
        isCancelInttraRequestSuccessVisible: true,
      });
    } else {
      message.error(response.errorMessage);
      this.setState({
        isCancellingInttraRequest: false,
      });
    }
  };

  renderCancelInttraRequestModal = () : React.ReactElement => {
    const { isCancelInttraRequestModalVisible, isCancellingInttraRequest } = this.state;
    const { cardData : { inttraReferenceNumber }, classes } = this.props;
    return (
      <Modal
        title="Cancel Request"
        visible={isCancelInttraRequestModalVisible}
        width={350}
        onCancel={() => this.toggleCancelInttraRequestModal(false)}
        destroyOnClose
        footer={
          <React.Fragment>
            <span
              className={classes.cancelButton}
              onClick={() => this.toggleCancelInttraRequestModal(false)}
            >Cancel</span>
            <Button
              loading={isCancellingInttraRequest}
              className={classes.cancelSubmit}
              onClick={() => this.handleCancelInttraRequest()}
            >Submit</Button>
          </React.Fragment>
        }
      >
        Are you sure you want to cancel
        {inttraReferenceNumber && <span style={{ fontWeight: 600 }}> INTTRA #{inttraReferenceNumber}</span>}
        ? This can't be undone.
        <div style={{ marginTop: '24px', fontSize: `${tokens.fontSize.small}px`, fontWeight: 600 }}>Remarks</div>
        <TextArea
          rows={2}
          onChange={e => this.setState({
            cancelRemark: e.target.value,
          })}
        />
      </Modal>
    );
  };

  handleSkipNow = () => {
    this.setState({
      isCancelInttraRequestSuccessVisible: false,
    });
    this.props.fetchAllBookings('FF');
  };

  renderCancelInttraSuccessModal = () : React.ReactElement => {
    const { isCancelInttraRequestSuccessVisible, loadingAmendBookingData, declining } = this.state;
    const { cardData : { inttraReferenceNumber, bookingNumber }, classes } = this.props;
    return (
      <Modal
        title={null}
        visible={isCancelInttraRequestSuccessVisible}
        width={480}
        closable={false}
        bodyStyle={{ padding: 0 }}
        footer={
          <Button
            className={classes.skipNowButton}
            onClick={() => this.handleSkipNow()}
          >Skip Now</Button>
        }
        onCancel={() => this.showDeclineConfirmationModal(false)}
      >
        <div className={classes.cancelInttraSuccessHeader}>
          <Icon type="check-circle" className={classes.successIcon} theme="filled" />
          <span>INTTRA {inttraReferenceNumber ? <strong>#{inttraReferenceNumber} </strong> : 'Request '}
            for Booking
          <strong> {bookingNumber}</strong> has been successfully cancelled </span>
        </div>
        <div style={{ padding: '16px', fontSize: `${tokens.fontSize.small}px` }}>
          <div style={{ fontWeight: tokens.fontWeight.semibold, color: '#424242' }}>Suggested Actions</div>
          <div className={classes.suggestedActionsDiv}>
            <div
              className={classes.suggestedActions}
              onClick={() => this.toggleAmendInttraRequestModal(true)}
            >
              {loadingAmendBookingData ?
                <Spin size="small" style={{ marginRight: '6px' }} />
                :
                <Icon type="reload" style={{ color: tokens.colors.primary, marginRight: '6px' }} />
              }
              Create New INTTRA Request
            </div>
            <div
              className={classes.suggestedActions}
              onClick={() => this.handleBookingDecline()}
            >
              {declining ?
                <Spin size="small" style={{ marginRight: '6px' }} />
                :
                <Icon type="close" style={{ color: '#F5222D', marginRight: '6px' }} />
              }
              Decline Shipper Request
            </div>
          </div>
        </div>
      </Modal>
    );
  };

  toggleCancelInttraRequestModal = (visible) => {
    this.setState({
      isCancelInttraRequestModalVisible: visible,
    });
  };

  toggleAmendInttraRequestModal = async (isCreateNew = false, isRetryInttraRequest = false) => {
    this.setState({
      loadingAmendBookingData: true,
    });
    const { cardData } = this.props;
    const response = await fetchBookingDetail({
      bookingId: cardData.id,
    });
    if (response.isSuccess) {
      this.setState({
        isCreateNew,
        isRetryInttraRequest,
        bookingDetail: response.data,
        loadingAmendBookingData: false,
        bookingDetailModalVisible: true,
        isAmend: !isCreateNew,
        isDropdownVisible: false,
      });
    } else {
      message.error(response.errorMessage);
      this.setState({
        loadingAmendBookingData: false,
      });
    }
  };

  handleSecondaryActions = (action) => {
    switch (action) {
      case 'uploadBookingNote': return this.handleBook(true);
      case 'declineShipperRequest': return this.showDeclineConfirmationModal(true);
      case 'cancelInttraRequest': return this.toggleCancelInttraRequestModal(true);
      case 'amendInttraRequest': return this.toggleAmendInttraRequestModal();
      case 'raiseNewInttraRequest': return this.toggleAmendInttraRequestModal(true);
      default: return;
    };
  };

  renderSLActions = (options) => {
    const { loadingBookingData, loadingAmendBookingData } = this.state;
    const { cardData : { inttraReferenceNumber } } = this.props;
    const loadingList = ['amendInttraRequest', 'raiseNewInttraRequest'];
    return (
      options &&
      Object.keys(options)?.map((key, index) => {
        const showLoader = ((loadingList?.indexOf(key) !== -1 && loadingAmendBookingData)) ||
          (key === 'uploadBookingNote' && loadingBookingData);
        return (
          <Menu.Item
            key={index}
            disabled={key === 'cancelInttraRequest' && !inttraReferenceNumber}
            onClick={() => {
              this.handleSecondaryActions(key);
              !(loadingList?.indexOf(key) !== -1 || key === 'uploadBookingNote') && this.setState({
                isDropdownVisible: false,
              });
            }}
          >
            {options[key]}
            {showLoader && <Spin size="small" style={{ paddingLeft: '4px' }} />}
          </Menu.Item>
        );
      })
    );
  };

  handleDropdownVisibleChange = (visible) => {
    const { loadingBookingData, loadingAmendBookingData } = this.state;
    const { cardData : { ffStatus } } = this.props;
    const isUploadDODropdown = (ffStatus === BOOKING_STATUS.SL_RESPONDED);
    if (isUploadDODropdown && (loadingBookingData || loadingAmendBookingData)) return;
    this.setState({
      isDropdownVisible: visible,
    });
  };

  renderActions = () : React.ReactElement => {
    const { isDropdownVisible } = this.state;
    return (
      <Dropdown trigger={['hover']}
        visible={isDropdownVisible}
        onVisibleChange={this.handleDropdownVisibleChange}
        overlay={this.getActionsDropdown()}>
        <Icon type="more" style={{ cursor: 'pointer' }} />
      </Dropdown>
    );
  };

  renderInttraRefNo = (inttraReferenceNumber) : React.ReactElement => {
    const { classes, cardData : {
      inttraStatus,
      showSplitBookingDetails,
      slBookingNumber,
      carrierComments,
      ffStatus,
    } } = this.props;
    return (
      <div className={classes.inttraRefNo}>
        {inttraReferenceNumber && <React.Fragment>
          INTTRA Reference # &nbsp;
          <span style={{ fontWeight: tokens.fontWeight.semibold, color: '#262626', marginRight: '6px' }}>
            {inttraReferenceNumber}
          </span>
        </React.Fragment>}
        {inttraStatus === SL_RESPONDED_INTTRA_STATUS.PARTIAL &&
          showSplitBookingDetails &&
          <span style={{ fontSize: `${tokens.fontSize.small}px`, color: tokens.colors.primary, cursor: 'pointer' }}
            onClick={() => this.setState({ isSplitBookingDetailsModalVisible: true })}
          >
            View split bookings
        </span>}
        {
          ffStatus === BOOKING_STATUS.SL_RESPONDED && (slBookingNumber || carrierComments) &&
          inttraStatus !== SL_RESPONDED_INTTRA_STATUS.PARTIAL &&
          <Tooltip title={this.renderConfirmedTooltip()}
            overlayClassName={classNames(classes.tooltipStyle, classes.tooltipRightArrow)}
            placement="topRight"
          >
            <Icon type="info-circle" theme="filled" style={{ marginLeft: '6px' }}/>
          </Tooltip>
        }
      </div>
    );
  };

  renderConfirmedStatusActions = () => {
    const { cardData } = this.props;
    const enableBookingNoteDownload = cardData?.confirmationDetails?.documents?.length && 
      cardData?.confirmationDetails?.documents?.filter((item) => item.type === 'DO')?.length;

    return enableBookingNoteDownload ?
      (<Row style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Col style={{ textAlign: 'right' }} span={24}>
          <a style={{ fontSize: `${tokens.fontSize.small}px`, color: tokens.colors.primary }}
            onClick={() => convertBookingNotesToZip(cardData)}>
            <Icon style={{ paddingRight: '4px', fontSize: `${tokens.fontSize.body}px` }} type="download" />
            View {cardData.inquiryMode === InquiryModes.TRAILER &&
            cardData.inquiryType === InquiryType.IMPORT ? 'DO' : 'Booking Note'} </a>
        </Col>
      </Row>) : null
  }

  renderOpenStatusActions = () => {
    const { cardData, permission } = this.props;
    const { connectionStatus, status } = cardData;
    return (
      permission && status === 'OPEN' &&
      connectionStatus === OrganisationOnboardingStatus.LINKED &&
      <Col style={{ textAlign: 'right' }} span={24}>
        <Row>
          <a style={{ fontSize: `${tokens.fontSize.small}px`, color: '#F5222D', paddingRight: '12px' }}
            onClick={this.showDeclineConfirmationModal}>
            Decline
          </a>
          <Button
            loading={this.state.loadingBookingData}
            type="primary"
            size="small"
            onClick={() => this.handleBook()}
            style={{
              fontSize: `${tokens.fontSize.small}px`, backgroundColor: tokens.colors.primary,
              border: 'none',
              textShadow: 'none',
            }}>Process Booking</Button>
        </Row>
      </Col>
    );
  };

  getSLResponseStatusData = (inttraStatus) => {
    switch (inttraStatus) {
      case SL_RESPONDED_INTTRA_STATUS.PARTIAL: return ({
        status: 'Replaced',
        backgroundColor: 'rgba(139,218,19,0.08)',
        borderColor: '#B6D942',
      });
      case SL_RESPONDED_INTTRA_STATUS.CONFIRMED: return ({
        status: 'Confirmed',
        backgroundColor: 'rgba(107,186,137,0.2)',
        borderColor: '#6BBA89',
      });
      case SL_RESPONDED_INTTRA_STATUS.REJECTED: return ({
        status: 'Rejected by SL',
        backgroundColor: 'rgba(245,34,45,0.08)',
        borderColor: '#F5222D',
      });
      case SL_RESPONDED_INTTRA_STATUS.PENDING: return ({
        status: 'Pending',
        backgroundColor: 'rgba(237,135,50,0.2)',
        borderColor: '#ED8732',
      });
      default: return;
    }
  }

  getSLRespondedAction = (inttraStatus) => {
    const { classes } = this.props;
    switch (inttraStatus) {
      case SL_RESPONDED_INTTRA_STATUS.REJECTED: return (
        <Col span={12}
          className={classes.slRejected}
          onClick={() => this.showDeclineConfirmationModal(true)}>
          Decline Booking
        </Col>
      );
      case SL_RESPONDED_INTTRA_STATUS.PARTIAL: return (
        <Col span={12} style={{ textAlign: 'right', paddingRight: '6px' }}>
          {this.renderCreateSplitBookings()}
        </Col>
      )
      case SL_RESPONDED_INTTRA_STATUS.CONFIRMED: return (
        <Col span={12} style={{ textAlign: 'right', paddingRight: '6px' }}>
          {this.renderUploadBookingNote()}
        </Col>
      );
      default: return;
    }
  };

  renderUploadBookingNote = () => {
    const { loadingBookingData } = this.state;
    return (
      <span style={{ fontSize: `${tokens.fontSize.small}px`, color: tokens.colors.primary, cursor: 'pointer' }}
        onClick={() => this.handleBook(true)}
      >
        {loadingBookingData ? <Spin size="small" style={{ paddingRight: '4px' }} /> :
        <Icon style={{ paddingRight: '4px', fontSize: `${tokens.fontSize.body}px` }} type="upload" />}
        Upload Booking Note
      </span>
    );
  };

  renderCreateSplitBookings = () => {
    const { isCreatingSplitBookings } = this.state;
    return (
      <span style={{ fontSize: `${tokens.fontSize.small}px`, color: tokens.colors.primary, cursor: 'pointer' }}
        onClick={() => this.setState({ isSplitConfirmationModalVisible: true })}
      >
        {isCreatingSplitBookings && <Spin size="small" style={{ paddingRight: '4px' }} />}
        Create Split Bookings
      </span>
    );
  };

  renderSplitConfirmationModal = () => {
    const { isSplitConfirmationModalVisible, isCreatingSplitBookings } = this.state;
    return (
      <Modal
        visible={isSplitConfirmationModalVisible}
        onOk={() => this.handleCreateSplitBookings()}
        okText="Submit"
        width={400}
        onCancel={() => this.setState({ isSplitConfirmationModalVisible: false })}
        title="Create Split Bookings"
        confirmLoading={isCreatingSplitBookings}
      >
        Are you sure you want to replace the parent booking into multiple split bookings?
      </Modal>
    );
  };

  renderSplitBookingDetailsModal = () => {
    const { isSplitBookingDetailsModalVisible } = this.state;
    const { cardData } = this.props;
    return (
      <SplitBookingDetailsModal
        isVisible={isSplitBookingDetailsModalVisible}
        bookingData={cardData}
        handleModalClose={() => this.setState({ isSplitBookingDetailsModalVisible: false })}
      />
    );
  };

  handleCreateSplitBookings = async () => {
    this.setState({ isCreatingSplitBookings: true });
    const response = await createSplitBookings(this.props.cardData.id);
    if (response.isSuccess) {
      this.props.fetchAllBookings('FF');
      this.setState({
        isCreatingSplitBookings: false,
        isSplitConfirmationModalVisible: false,
      });
    } else {
      message.error(response.errorMessage);
      this.setState({
        isCreatingSplitBookings: false,
      });
    }
  };

  renderRetryInttraRequest = () => {
    const { loadingAmendBookingData } = this.state;
    return (
      <span style={{ fontSize: `${tokens.fontSize.small}px`, color: tokens.colors.primary, cursor: 'pointer' }}
        onClick={() => this.toggleAmendInttraRequestModal(false, true)}
      >
        {loadingAmendBookingData && <Spin size="small" style={{ paddingRight: '4px' }} />}
        Retry Request
      </span>
    );
  };

  renderSLRespondedActions = () => {
    const { cardData : {
      inttraStatus,
      inttraBookingRejectionReason,
      slBookingNumber,
      carrierComments,
      ffStatus,
    }, classes } = this.props;
    const statusWiseData = this.getSLResponseStatusData(inttraStatus);
    return (
      <div className={classes.slResponded}>
        <Col span={11}>
          <span
            style={{
              backgroundColor: statusWiseData?.backgroundColor,
              border: `1px solid ${statusWiseData?.borderColor}`,
            }}
            className={classes.slRespondedStatus}
          >{statusWiseData?.status}</span>
           {(
             inttraStatus === SL_RESPONDED_INTTRA_STATUS.REJECTED
           ) && isValidString(inttraBookingRejectionReason) &&
            <Tooltip title={inttraBookingRejectionReason} overlayClassName={classes.tooltipStyle}>
              <Icon type="info-circle" theme="filled" />
            </Tooltip>}
            {
              ffStatus === BOOKING_STATUS.SL_RESPONDED && (slBookingNumber || carrierComments) &&
              inttraStatus === SL_RESPONDED_INTTRA_STATUS.PARTIAL &&
              <Tooltip title={this.renderConfirmedTooltip()} overlayClassName={classes.tooltipStyle}>
                <Icon type="info-circle" theme="filled" />
              </Tooltip>
            }
        </Col>
        {this.getSLRespondedAction(inttraStatus)}
        <Col span={1}>{this.renderActions()}</Col>
      </div>
    );
  };

  renderSLResponseAwaitedActions = () => {
    return (
      <Col span={24} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        {this.renderActions()}
      </Col>
    );
  };

  renderErrorsReceivedActions = () => {
    const { cardData : { inttraErrorReasons }, classes } = this.props;
    const tooltip = isValidArray(inttraErrorReasons) && getConditionalBullets(inttraErrorReasons);
    return (
      <Row style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <React.Fragment>
          <Col span={14}>
            <span
              style={{
                backgroundColor: 'rgba(245,34,45,0.08)',
                border: `1px solid #F5222D`,
                display: 'inline-block',
              }}
              className={classes.slRespondedStatus}
            >Failed INTTRA Request</span>
            {isValidArray(inttraErrorReasons) && <Tooltip title={tooltip} overlayStyle={{ fontSize: `${tokens.fontSize.small}px` }}>
              <Icon type="info-circle" theme="filled" />
            </Tooltip>}
          </Col>
          <Col span={9} style={{ textAlign: 'right', paddingRight: '6px' }}>
            {this.renderRetryInttraRequest()}
          </Col>
        </React.Fragment>
        <Col span={1}>
          {this.renderActions()}
        </Col>
      </Row>
    );
  };

  renderCancelledActions = () => {
    const { cardData : { inttraStatus }, showInttraBookingFF } = this.props;
    const canncelInttraRequest = showInttraBookingFF && [
      SL_RESPONDED_INTTRA_STATUS.INTTRA_REQUEST_SUBMITTED,
      SL_RESPONDED_INTTRA_STATUS.INTTRA_REQUEST_ACCEPTED,
      SL_RESPONDED_INTTRA_STATUS.CONFIRMED,
      SL_RESPONDED_INTTRA_STATUS.PENDING,
    ].includes(inttraStatus);
    return (
      canncelInttraRequest && <React.Fragment>
        <Col span={24} style={{ textAlign: 'right' }}>
        <span style={{ fontSize: `${tokens.fontSize.small}px`, color: tokens.colors.primary, cursor: 'pointer' }}
          onClick={() => this.toggleCancelInttraRequestModal(true)}
        >
          Cancel INTTRA Request
        </span>
        </Col>
      </React.Fragment>
    );
  };

  getStatusWiseActions = (ffStatus) => {
    switch (ffStatus) {
      case BOOKING_STATUS.CONFIRMED: return this.renderConfirmedStatusActions();
      case BOOKING_STATUS.OPEN: return this.renderOpenStatusActions();
      case BOOKING_STATUS.SL_RESPONDED: return this.renderSLRespondedActions();
      case BOOKING_STATUS.SL_RESPONSE_AWAITED: return this.renderSLResponseAwaitedActions();
      case BOOKING_STATUS.SL_ERRORED: return this.renderErrorsReceivedActions();
      case BOOKING_STATUS.CANCELLED: return this.renderCancelledActions();
      default: return;
    };
  };

  renderConfirmedTooltip = () => {
    const { cardData : { slBookingNumber, carrierComments }} = this.props;
    return (
      <div style={{ fontSize: `${tokens.fontSize.small}px` }}>
        {slBookingNumber && <div>
          <span style={{ fontWeight: 600 }}>SL Booking #</span>:
          <span style={{ fontSize: `${tokens.fontSize.caption}px` }}> {slBookingNumber}</span>
        </div>}
        {carrierComments && <div style={{ marginTop: '12px', display: 'flex' }}>
          <span style={{ fontWeight: 600 }}>Remarks</span>:
          <span style={{ fontSize: `${tokens.fontSize.caption}px` }}> {getConditionalBullets(carrierComments)}</span>
        </div>}
      </div>
    );
  };

  renderDataCol4 = () => {
    const { cardData, handleReload, showInttraBookingFF, invoicePermission, classes } = this.props;
    const { isDeclineModalVisible } = this.state;
    const { connectionStatus, inttraReferenceNumber, bookingNumber, ffStatus } = cardData;
    return (
      <div style={{ width: '100%' }}>
        <Col span={24} style={{ height: '100%' }}>
          <Row style={{ display: 'flex' }}>
            <Col span={19}>{this.col4Status()}</Col>
            <Col span={5} style={{ marginBottom: '-10px' }}>
              <CommentCount
                prefetchedCount={cardData.commentCount}
                isLoading={this.props.isLoading}
                commentApiPrefix={'booking'}
                style={{
                  float: 'right',
                }}
                sourceObjectId={cardData.id}
                modalHeader={this.renderCommentModalHeader()} />
            </Col>
          </Row>
          <Row>{this.getStatusDate()}</Row>
          {showInttraBookingFF &&
            <Row>
              {this.renderInttraRefNo(inttraReferenceNumber)}
            </Row>
          }
          <Row className={classes.actionsDiv}>
            {connectionStatus !== OrganisationOnboardingStatus.LINKED ?
              <ConnectionStatusInquiry
                handleReload={handleReload}
                inquiryData={cardData}
              />
              :
              <React.Fragment>
                {this.getStatusWiseActions(cardData.ffStatus)}
                <Modal
                  title="Decline Request"
                  confirmLoading={this.state.declining}
                  visible={isDeclineModalVisible}
                  onOk={this.handleBookingDecline}
                  width={350}
                  okText="Submit"
                  destroyOnClose
                  onCancel={() => this.showDeclineConfirmationModal(false)}
                >
                  Are you sure you want to decline
                  <span style={{ fontWeight: 600 }}> Booking #{bookingNumber}</span>
                  ? This can't be undone.
                  {[BOOKING_STATUS.SL_RESPONDED,
                    BOOKING_STATUS.SL_RESPONSE_AWAITED,
                    BOOKING_STATUS.SL_ERRORED].includes(ffStatus) &&
                    <React.Fragment>
                      <div style={{ marginTop: '24px', fontSize: `${tokens.fontSize.small}px`, fontWeight: 600 }}>Remarks</div>
                      <TextArea
                        rows={2}
                        placeholder="Share cancellation remarks with carrier"
                        onChange={e => this.setState({
                          cancellationRemarksWithCarrier: e.target.value,
                        })}
                      />
                  </React.Fragment>}
                </Modal>
              </React.Fragment>
            }
            {/* {invoicePermission ?
              <Button type="primary"
                size="small"
                style={{
                  backgroundColor: tokens.colors.primary,
                  border: '1px solid #1890FF',
                }}
                onClick={() => this.handleAddNewInvoice(cardData)}>
                Add Invoice
          </Button> : null} */}
          </Row>
        </Col>
      </div>
    );
  }

  renderColumn = (span, elem, renderBorder = true, paddingLeft = '32px') => {
    const { classes } = this.props;
    return <Col span={span} style={{ display: 'flex', flex: 1, paddingLeft }}
      className={renderBorder ? classes.colParent : undefined}>
      {elem}
    </Col>;
  }

  closeBookingDetail = (showProtip = false) => {
    this.setState({
      bookingDetailModalVisible: false,
      confirmBookingProtipVisible: showProtip,
      isAmend: false,
      isCreateNew: false,
      isRetryInttraRequest: false,
    });
  }

  renderCommentModalHeader = () => {
    const { cardData, classes } = this.props;
    const originCountry = cardData.origin?.countryName;
    const destinationCountry = cardData.destination?.countryName;
    const bidRankData = cardData.bidDetails;
    const roadModes = [InquiryModes.DOMESTIC, InquiryModes.RPTL];
    const isDomesticMode = roadModes.includes(cardData.inquiryMode);

    return (
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%' ,
        margin: '0px 16px',
      }}>
        <a className={classes.bookingNum}
          style={{ alignSelf: 'center' }}
          onClick={this.handleClickBookingNumber}>
          {cardData.bookingNumber}
        </a>

        <div style={{
          borderRight: '1px solid #E8E8E8',
        }}/>

        <div style={{
          display: 'flex',
          alignSelf: 'center',
        }}>
          <div style={{
            display: 'flex',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            alignItems: 'center',
          }}>
            {commentsLocationDetails(cardData, 'ORIGIN')}
          </div>
        </div>

        <div style={{
          display: 'flex',
          alignSelf: 'center',
          width: '20%'
        }}>
          {this.renderDot({ backgroundColor: COLORS.GREY }, '')}
          <div style={{
            marginTop: '6px',
            width: '100%',
          }}>
            {this.renderLine(COLORS.GREY)}
          </div>
          {this.renderDot({ border: `1px solid ${COLORS.GREY}` }, '')}
        </div>

        <div style={{
          display: 'flex',
          alignSelf: 'center',
          alignItems: 'center',
        }}>
          {commentsLocationDetails(cardData, 'DESTINATION')}
        </div>

        <div style={{
          borderRight: '1px solid #E8E8E8',
        }}/>

        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignSelf: 'center',
        }}>
          <div>
            <PriceTotal
              commentTextStyle={true}
              amount={bidRankData.finalPrice.amount}
              currencySymbol={
                this.props.currencySymbols[`${bidRankData.finalPrice.currency}`]
              } />
              {isDomesticMode ? '' : <PricePerContainer
              commentTextStyle={true}
              amount={bidRankData.totalPerUnit && bidRankData.totalPerUnit.amount}
              currency={bidRankData.totalPerUnit && bidRankData.totalPerUnit.currency}
              containerTypes={bidRankData.totalPerUnitType}
              mode={cardData.inquiryMode}
              sourceObjectType={'BOOKING'} />}
          </div>
        </div>

        <div style={{ height: '40px' }}>
            <img src={bidRankData.shippingLineLogoUrl} />
        </div>

        <div style={{
          fontSize: `${tokens.fontSize.body}px`,
          color: '#262626',
          alignSelf: 'center',
          fontWeight: tokens.fontWeight.semibold,
        }}>
          {cardData.shipperName}
        </div>
      </div>
    );
  }

  render() {
    const { cardData: data, classes } = this.props;
    const {
      bookingDetailModalVisible,
      isUploadDOModalVisible,
      isCancelInttraRequestModalVisible,
      isCancelInttraRequestSuccessVisible,
      isAmend,
      isCreateNew,
      isRetryInttraRequest,
      isSplitConfirmationModalVisible,
      isSplitBookingDetailsModalVisible,
    } = this.state;
    return (
      <div style={
        ((data.status === 'CONFIRMED') ? { border: `1px solid ${COLORS.GREEN}` } : undefined)}
        className={classes.cardContainer}>
        <Row>
          {this.renderColumn(4, this.renderDataCol1(), false, '0px')}
          {this.renderColumn(9, this.renderDataCol2())}
          {this.renderColumn(4, this.renderDataCol3())}
          {this.renderColumn(7, this.renderDataCol4(), true, '12px')}
        </Row>
        {bookingDetailModalVisible &&
          <BookingDetail
            cardData={this.props.cardData}
            handleCancel={this.closeBookingDetail}
            bookingData={this.state.bookingDetail}
            bookingId={this.props.cardData.bookingNumber}
            visible={bookingDetailModalVisible}
            isAmend={isAmend}
            isCreateNew={isCreateNew}
            isRetryInttraRequest={isRetryInttraRequest} />}
        {isUploadDOModalVisible && this.renderBookingFFModal()}
        {isCancelInttraRequestModalVisible && this.renderCancelInttraRequestModal()}
        {isCancelInttraRequestSuccessVisible && this.renderCancelInttraSuccessModal()}
        {isSplitConfirmationModalVisible && this.renderSplitConfirmationModal()}
        {isSplitBookingDetailsModalVisible && this.renderSplitBookingDetailsModal()}
      </div>);
  }
}

const mapStateToProps = ({ masterData, staticData, bookingInquiryReducer }) => ({
  currencySymbols: masterData.currencySymbols,
  containerTypes: staticData.containerTypesKeyVal,
  permission: masterData.permissions.INQUIRY_BIDDING_ALL_ACTIONS,
  invoicePermission: masterData.modules.show_invoice_receivable,
  appliedFilters: bookingInquiryReducer.appliedFilters,
  showInttraBookingFF: masterData.modules.show_inttra_booking_ff,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  getAllInquiriesResetFilter,
  getAllInquiriesApplyFilter,
  fetchAllBookings,
}, dispatch));

const InquiryFFCardStyledStyled = injectSheet(styles)(InquiryFFCardStyled);
export default withRouter(connect(mapStateToProps,
  mapDispatchToProps)(withAuthAccessExim([INQUIRY_FF])(InquiryFFCardStyledStyled)));
